export const API_BASE_URL = 'https://cmsapi.mks.org.au';
export const IMG_BASE = `${API_BASE_URL}/uploads/`;
